// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31b7s","header":"ReportDetails_header__2HfZ7","title":"ReportDetails_title__3-wr7","left":"ReportDetails_left__Ll7Vb"};